// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"searchDeck_checkboxes__YqS_a","element":"searchDeck_element__izvtq"};